// eslint-disable-next-line no-unused-vars
import React from 'react';
import { bool, object, string } from 'prop-types';
import styled from '@emotion/styled';
import { Button, Loading } from '@carbon/react';

const StyledButton = styled(Button)`
  width: auto;
  max-width: fit-content;
  height: 40px;
  padding: 0 20px !important;
  justify-content: center;
  border-radius: 6px;

  &.loading {
    padding-left: 40px !important;
  }

  &.primary {
    background: #fff;
    border: 1px solid #1f59a2;
    color: #1f59a2;
  }

  &.danger {
    background-color: #da1e28;
    border: 1px solid transparent;
    color: #fff;
  }

  svg {
    height: 16px;
    width: 16px;
  }
`;

const NWButton = ({ className, children, loading, ...rest }) => (
  <StyledButton
    disabled={ loading || rest.disabled }
    className={ `styledButton ${ className } ${ loading ? 'loading' : '' } ${ rest.kind ? rest.kind : '' }` }
    { ...rest }
  >
    { loading && <Loading active withOverlay={ false } small /> }
    { children }
  </StyledButton>
);

NWButton.propTypes = {
  className: string,
  children: object,
  loading: bool,
};

export { NWButton };
